"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Location_utils_1 = require("../Locations/Location.utils");
const prop_types_1 = __importDefault(require("prop-types"));
const styles_1 = require("./styles");
/**
 * Component to render the location dropdown address
 *
 * @param {object} param0 Input props for the component
 * @param {string} param0.street1 Street 1
 * @param {string} param0.street2 Street 2
 * @param {string} param0.suite Suite
 * @param {string} param0.city City
 * @param {string} param0.state State
 * @param {string} param0.zip Zip
 *
 * @returns
 */
const LocationDropdownAddress = ({ street1, street2, suite, city, state, zip }) => (react_1.default.createElement(styles_1.LocationDropdownAddressContainer, null,
    react_1.default.createElement(Location_utils_1.Street, { street1: street1, street2: street2, suite: suite }),
    ', ',
    react_1.default.createElement(Location_utils_1.City, null,
        city,
        Boolean(state || zip) && ', '),
    react_1.default.createElement(Location_utils_1.State, null,
        state,
        "\u00A0"),
    react_1.default.createElement(Location_utils_1.Zip, null, zip)));
LocationDropdownAddress.propTypes = {
    street1: prop_types_1.default.string,
    street2: prop_types_1.default.string,
    suite: prop_types_1.default.string,
    city: prop_types_1.default.string,
    state: prop_types_1.default.string,
    zip: prop_types_1.default.string
};
exports.default = LocationDropdownAddress;
//# sourceMappingURL=LocationDropdownAddress.js.map